{
  "name": "distube",
  "version": "4.2.2",
  "description": "A Discord.js module to simplify your music commands and play songs with audio filters on Discord without any API key.",
  "main": "./dist/index.js",
  "types": "./dist/index.d.ts",
  "exports": "./dist/index.js",
  "directories": {
    "lib": "src",
    "test": "tests"
  },
  "files": [
    "dist"
  ],
  "scripts": {
    "test": "jest",
    "docs": "typedoc",
    "lint": "prettier --check . && eslint .",
    "lint:fix": "eslint . --fix",
    "prettier": "prettier --write \"**/*.{ts,json,yml,yaml,md}\"",
    "build": "tsup",
    "build:check": "tsc --noEmit",
    "update": "pnpm up -L",
    "postinstall": "husky",
    "prepublishOnly": "pnpm run lint && pnpm run test",
    "prepack": "pnpm run build && pinst --disable",
    "postpack": "pinst --enable",
    "dev:add-docs-to-worktree": "git worktree add --track -b docs docs origin/docs"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/skick1234/DisTube.git"
  },
  "keywords": [
    "youtube",
    "music",
    "discord",
    "discordjs",
    "bot",
    "distube",
    "queue",
    "musicbot",
    "discord-music-bot",
    "music-bot",
    "discord-js"
  ],
  "author": "Skick (https://github.com/skick1234)",
  "license": "MIT",
  "bugs": {
    "url": "https://github.com/skick1234/DisTube/issues"
  },
  "funding": "https://github.com/skick1234/DisTube?sponsor=1",
  "homepage": "https://distube.js.org/",
  "dependencies": {
    "@distube/ytdl-core": "^4.13.3",
    "@distube/ytpl": "^1.2.1",
    "@distube/ytsr": "^2.0.0",
    "tiny-typed-emitter": "^2.1.0",
    "tough-cookie": "^4.1.3",
    "tslib": "^2.6.2",
    "undici": "^6.13.0"
  },
  "devDependencies": {
    "@babel/core": "^7.24.4",
    "@babel/plugin-transform-class-properties": "^7.24.1",
    "@babel/plugin-transform-object-rest-spread": "^7.24.1",
    "@babel/plugin-transform-private-methods": "^7.24.1",
    "@babel/preset-env": "^7.24.4",
    "@babel/preset-typescript": "^7.24.1",
    "@commitlint/cli": "^19.2.2",
    "@commitlint/config-conventional": "^19.2.2",
    "@discordjs/voice": "^0.16.1",
    "@types/jest": "^29.5.12",
    "@types/node": "^20.12.7",
    "@types/tough-cookie": "^4.0.5",
    "@typescript-eslint/eslint-plugin": "^7.7.0",
    "@typescript-eslint/parser": "^7.7.0",
    "babel-jest": "^29.7.0",
    "discord.js": "^14.14.1",
    "eslint": "^8.57.0",
    "eslint-config-distube": "^1.7.0",
    "husky": "^9.0.11",
    "jest": "^29.7.0",
    "nano-staged": "^0.8.0",
    "pinst": "^3.0.0",
    "prettier": "^3.2.5",
    "tsup": "^8.0.2",
    "typedoc": "^0.25.13",
    "typedoc-material-theme": "^1.0.2",
    "typescript": "^5.4.5"
  },
  "peerDependencies": {
    "@discordjs/voice": "*",
    "discord.js": "14"
  },
  "nano-staged": {
    "*.ts": [
      "prettier --write",
      "eslint"
    ],
    "*.{json,yml,yaml,md}": [
      "prettier --write"
    ]
  },
  "engines": {
    "node": ">=18.17"
  }
}
